import { Text, Card } from '@/components'
import { match } from 'ts-pattern'
import { RewardRow } from './RewardRow'
import { Transaction } from '@/types/transaction'
import TransactionDisplayModal, {
  hasTransactionDetails,
} from '../components/transactionDisplayModal'
import { ActivityViewModelProps } from './Activity.viewmodel'
import { TransactionIcon } from '../components/TransactionIcon'
import clsx from 'clsx'
import { formatPoints } from '@/utils/rewardPoints'
import { formatRewardDate } from '../../rewards.utils'

export function getTransactionLabel(transaction: Transaction): string {
  return (
    match(transaction.type)
      .with('referral', () => 'Invitation Bonus')
      .with('redeem', () => 'Reward redemption')
      .with('expire', () => 'Expired reward')
      .with('program_referral', () => 'Program Referral')
      .with('reward_program', () => 'Program reward')
      .with('reward_program_signup', () => 'Program Sign-Up')
      // Manually granted credits and corrections come back without a type
      .with(null, () => (transaction.points < 0 ? 'Adjustment' : 'Reward'))
      .exhaustive()
  )
}

export const CompletedTransactionsCard = (props: ActivityViewModelProps) => {
  if (!props.completedTransactions.length) return null

  const completedTransactions = props.completedTransactions.slice(
    0,
    props.loadedTransactions,
  )

  return (
    <Card className="w-full">
      <div className="w-full flex justify-start flex-col">
        <Text variant="h3">Transactions</Text>
        <div className="w-full flex flex-col items-center divide-y divide-solid divide-gray-200">
          {completedTransactions?.map((transaction) => {
            const hasDetails = hasTransactionDetails(transaction)
            return (
              <RewardRow
                icon={<TransactionIcon type={transaction.type} />}
                label={getTransactionLabel(transaction)}
                description={formatRewardDate(transaction.created)}
                showInfoIcon={hasDetails}
                key={transaction.id}
                onClick={
                  hasDetails
                    ? () => props.setTransactionToDisplay(transaction)
                    : undefined
                }
                label2={
                  <Text
                    className={clsx(
                      'text-sm font-bold whitespace-nowrap',
                      transaction.type === 'redeem'
                        ? 'text-green-700'
                        : 'text-gray-900',
                    )}
                  >
                    {formatPoints(transaction.points, { signed: true })}
                  </Text>
                }
              />
            )
          })}
          {props.loadedTransactions < props.completedTransactions.length && (
            <div
              onClick={props.loadMore}
              className="w-full text-center pt-5 cursor-pointer"
            >
              <Text className="text-sm font-medium text-blue-600">
                Load More
              </Text>
            </div>
          )}
        </div>
        <TransactionDisplayModal
          transaction={props.transactionToDisplay}
          onClose={() => props.setTransactionToDisplay(null)}
        />
      </div>
    </Card>
  )
}
